import ErrorPage from '@client-hub/shared/react/components/ErrorPage'

const Error = () => <ErrorPage height="100vh" width="100vw" />

export default Error
